import { render, staticRenderFns } from "./client-profiles-table.vue?vue&type=template&id=274b9e6a"
import script from "./client-profiles-table.vue?vue&type=script&lang=js"
export * from "./client-profiles-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports